import { useHistory } from "react-router";
import { faIdBadge } from "@fortawesome/free-solid-svg-icons";

import { MenuButton } from "types-and-validators/MenuButton";

interface ProfileUser {
	uid: string;
}

export function useMenuButtonNavigateToProfile() {
	const history = useHistory();

	return ({ uid }: ProfileUser) => {
		const output: MenuButton = {
			onClick: () => {
				history.push(`/user-id/${uid}`);
			},
			label: "View profile",
			icon: faIdBadge
		};

		return output;
	};
}
